import Vue from 'vue';
import { Module } from 'vuex';

import { Course, RootState } from 'frontend/types';

interface CourseState {
  course: Course | undefined;
}

const course: Module<CourseState, RootState> = {
  namespaced: true,
  state: () => ({
    course: undefined,
  }),
  mutations: {
    setValue(state, value: Course): void {
      Vue.set(state, 'course', value);
    },
  },
};

export default course;
